export default {
  publicUrl: process.env.REACT_APP_PUBLIC_URL,
  authApiBase: process.env.REACT_APP_API_BASE_URL,
  docsApi: process.env.REACT_APP_API_DOCS_URL,
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  sentryTracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
};
